module.exports = __webpack_public_path__ + "static/media/djurgarden_pingis_collage_500px.7fa5e53b.jpg";